import { Translation } from '@ps/web-shared-components';
import React from 'react';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import useTrackers from '@swf/core/hooks/useTrackers';
import type { ExtraWallet } from '@swf/core/models/sports/types/extraWallets';
import { getIsWalletBonusCash } from '@swf/core/models/sports/utils/extraWallets/getIsWallet';
import { Icon } from '@swf/sports/components';
import SportsFormattedTimeZone from '@swf/sports/components/SportsFormattedTimeZone/SportsFormattedTimeZone';
import useBonusAction from '@swf/sports/hooks/useBonusAction';

import {
  TXTCLI_ExpiresX_N0,
  TXTWCL_N0_Bonus_Cash,
  TXTWCL_N0_Free_Bet
} from './WalletDetail.messages.json';
import styles from './WalletDetail.scss';

const WalletDetail: React.FC<ExtraWallet> = (wallet) => {
  const { buttonPressed } = useTrackers();

  const isBonusCash = getIsWalletBonusCash(wallet);
  const { action } = useBonusAction(isBonusCash);
  const bonusClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    buttonPressed({ buttonName: 'Offer Info' });

    action();
  };

  return (
    <button type="button" className={styles.bonusCash} onClick={bonusClick}>
      <span className={styles.bonusCashAmount}>
        {}
        <Translation
          {...(isBonusCash ? TXTWCL_N0_Bonus_Cash : TXTWCL_N0_Free_Bet)}
          values={{
            0: <CurrencyAmount value={wallet.amount} dollarValue currency={wallet.currency} />
          }}
        />
      </span>
      <span className={styles.bonusCashExpiry}>
        <Translation
          {...TXTCLI_ExpiresX_N0}
          values={{
            0: <SportsFormattedTimeZone date={wallet.expiry} format="medium" />
          }}
        />
      </span>

      <Icon name="chevron-medium-right" size="xl" className={styles.iconChevron} />
    </button>
  );
};

export default WalletDetail;
